if ( typeof QuickAddToCart !== 'function' ) {

    class QuickAddToCart extends HTMLElement {
        constructor(){
            super();
            if ( this.querySelector('product-form') ) {
                this.init();
            }
        }
        init(){
            this.querySelector('product-form').addEventListener('add-to-cart', ()=>{
                if ( ! document.body.classList.contains('template-cart') ) {
                    document.getElementById('site-cart-sidebar').show();
                    if ( document.getElementById('cart-recommendations') ) {
                        document.getElementById('cart-recommendations').generateRecommendations();
                    }
                    document.querySelectorAll('[data-header-cart-total]').forEach(elm=>{
                        elm.textContent = document.querySelector('#AjaxCartForm [data-cart-total]').textContent;
                    });
                    document.querySelectorAll('[data-header-cart-count]').forEach(elm=>{
                        elm.textContent = document.querySelector('#AjaxCartForm [data-cart-count]').textContent;
                    });
                }
            });
        }
    }

    if ( typeof customElements.get('quick-add-to-cart') == 'undefined' ) {
        customElements.define('quick-add-to-cart', QuickAddToCart);
    }

}

if ( typeof QuickViewProduct !== 'function' ) {

    class QuickViewProduct extends HTMLElement {
        constructor(){
            super();
            if ( this.querySelector('a') ) {
                this.init();
            }
        }

        init(){

            this.quickViewModal = null;

            this.querySelector('a').addEventListener('click', async (e)=>{

                e.preventDefault();

                const target = e.currentTarget;
                const productUrl = target.getAttribute('href');

                if ( this.quickViewModal ) {
                    this.quickViewModal.show();
                    return;
                }

                try {

                    target.classList.add('working');

                    const url = `${productUrl}${ productUrl.includes('?') ? '&' : '?' }sections=main`;
                    const response = await fetch(url);
                    const data = await response.json();

                    if ( ! data || ! data.main ) {
                        window.location.href = productUrl;
                        return;
                    }

                    const parsed = new DOMParser().parseFromString(data.main, 'text/html');
                    const productContent =
                        parsed.querySelector('product-page') ||
                        parsed.querySelector('#product-quick-view') ||
                        parsed.body;

                    if ( ! productContent ) {
                        window.location.href = productUrl;
                        return;
                    }

                    const quickViewContainer = document.createElement('div');
                    quickViewContainer.innerHTML = `<modal-box id="modal-${target.dataset.id}"  
                        class="modal modal--product" 
                        data-options='{
                            "enabled": false,
                            "showOnce": false,
                            "blockTabNavigation": true
                        }'
                        tabindex="-1" role="dialog" aria-modal="true" 
                    >
                        <div class="container--medium">
                            <div class="modal-content">
                                <button class="modal-close" data-js-close data-js-first-focus style="position:absolute;margin:0;top:0;right:0">${window.KROWN.settings.symbols.close}</button>
                            </div>
                        </div>
                        <span class="modal-background" data-js-close></span>
                    </modal-box>`;

                    this.quickViewModal = quickViewContainer.querySelector('modal-box');
                    document.body.appendChild(this.quickViewModal);

                    this.quickViewModal.querySelector('.modal-content').innerHTML = productContent.outerHTML;

                    if ( ! window.productPageScripts ) {
                        const scripts = this.quickViewModal.querySelectorAll('script[src]');
                        scripts.forEach(elm=>{
                            const script = document.createElement('script');
                            script.src = elm.src;
                            script.defer = true;
                            document.body.append(script);
                        });
                        window.productPageScripts = true;
                    }

                    const closeBtn = this.quickViewModal.querySelector('.product-quick-view__close');
                    if ( closeBtn ) {
                        closeBtn.addEventListener('click', ()=>{
                            this.quickViewModal.hide();
                        });
                    }

                    const productForm = this.quickViewModal.querySelector('[data-js-product-form], .product-form');
                    if ( productForm ) {
                        productForm.addEventListener('add-to-cart', ()=>{
                            this.quickViewModal.hide();
                        });
                    }

                    setTimeout(()=>{
                        this.quickViewModal.show();
                        target.classList.remove('working');
                    }, 150);

                } catch(error) {
                    target.classList.remove('working');
                    window.location.href = productUrl;
                }

            });
        }
    }

    if ( typeof customElements.get('quick-view-product') == 'undefined' ) {
        customElements.define('quick-view-product', QuickViewProduct);
    }

}